import { formatDuration } from "../utils/utils"
import How from "./how"

const Prestation=(props)=>{
 
return(
    <div key={props?.key} className={`${props?.selected ? 'selected-prestation mt-8' :'' }  prestation-item ${props?.className}`}>
    <div className="row">
      <div className="col-md-7">
        <h5 className="grey500 mb-0 break-all">{props?.prestation.name}</h5>
        <div className="d-flex align-items-center flex-wrap mt-4">
        <span className="body grey500"> { formatDuration(props?.prestation?.nbr_sceance*props?.prestation?.duree)} </span>

        <span className="ellipse mx-8"></span>
          <span className="body grey500"> {props?.prestation?.nbr_sceance} rendez-vous de {formatDuration(props?.prestation?.duree)} </span>
          <span className="ellipse mx-8"></span>
          <span className="body grey500">{props?.prestation.ttc} €</span>
        </div>
        <p className="body grey66 mt-8 mb-0 break-all">{props?.prestation.description}</p>
      </div>
      <div className="col-md-5 d-flex flex-column justify-content-between">
      {props?.classNameBtn ? 
      <div className="text-end">
      <button className={props?.classNameBtn} onClick={props?.buttonAction}>{props?.buttonName}</button>
    </div>:""}  
        <div className=" mt-8">
          <How lieu_intervention={props?.prestation?.lieu}  />
        </div>
      </div>
    </div>
  </div>
)
}
export default Prestation